import styled from 'styled-components';

import { translate } from '@vimeo/i18n-runtime';

import T from '../../../translate';
import { useRouterPath } from '../../hooks';
import { useGlobalStore } from '../../state/globalStore';
import { Padding } from '../../styles/commonStyle';
import { KEY_CODES, PREVIEW_TYPE } from '../../utils/constants';
import { EventDate } from '../common/EventDate';
import { Alignment, WrapperBox } from '../previewStyles';

const RegistrationFull = () => {
  const leadCaptureProperties = useGlobalStore((state) => state.leadCapture);
  const {
    logo,
    alignment,
    nonEditableTextStyle: { alreadyRegistered: alreadyRegisteredStyle }
  } = leadCaptureProperties;
  const {
    entity: { title: eventTitle }
  } = useGlobalStore((store) => store);
  const { onPreviewChange } = useRouterPath();

  return (
    <Alignment align={alignment} addPadding>
      <WrapperBox paddingBottom={98}>
        {logo.isActive &&
        <a
          {...logo.isLinkActive &&
          logo.customLink?.length > 0 && { href: logo.customLink, target: '_blank' }}>
          
            <Logo src={logo.url} />
          </a>
        }
        <Title>
          <div>{T.RegistrationFullMessage}</div>
          <EventTitle>{eventTitle}</EventTitle>
        </Title>
        <Padding top={16} left={4} right={4}>
          <EventDate />
        </Padding>
        <StyledLoginTextWrapper>
          <StyledLoginText color={alreadyRegisteredStyle.color}>
            {translate({
              singular: 'Already registered? {LINK}Sign in{/LINK}',
              replacements: {
                LINK: (text: string) =>
                <Pointer
                  tabIndex={0}
                  onKeyPress={(e) =>
                  e.key === KEY_CODES.ENTER && onPreviewChange(PREVIEW_TYPE.LOGIN_SCREEN)
                  }
                  onClick={() => onPreviewChange(PREVIEW_TYPE.LOGIN_SCREEN)}>
                  
                    {text}
                  </Pointer>

              }, dictionary: { "es": { singular: "\xBFYa est\xE1 registrado? {LINK}Inicie sesi\xF3n{/LINK}" }, "de-DE": { singular: "Schon registriert? {LINK}Einloggen{/LINK}" }, "fr-FR": { singular: "D\xE9j\xE0 inscrit(e)\xA0? {LINK}Connectez-vous{/LINK}" }, "ja-JP": { singular: "\u3059\u3067\u306B\u3054\u767B\u9332\u6E08\u307F\u3067\u3059\u304B\uFF1F {LINK}\u30ED\u30B0\u30A4\u30F3{/LINK}" }, "ko-KR": { singular: "\uC774\uBBF8 \uAC00\uC785\uD558\uC168\uB098\uC694? {LINK}\uB85C\uADF8\uC778{/LINK}" }, "pt-BR": { singular: "J\xE1 se inscreveu? {LINK}Fa\xE7a o login{/LINK}" }, "zh-CN": { singular: "\u5DF2\u7ECF\u6CE8\u518C\uFF1F{LINK}\u767B\u5F55{/LINK}" } }
            })}
          </StyledLoginText>
        </StyledLoginTextWrapper>
      </WrapperBox>
    </Alignment>);

};

const Logo = styled.img`
  max-height: 56px;
  margin-bottom: 16px;
  margin-left: 8px;
  margin-right: 8px;
`;

const Pointer = styled.u`
  cursor: pointer;
`;

const StyledLoginTextWrapper = styled.div`
  padding: 0 4px;
  margin-top: 16px;
`;

const StyledLoginText = styled.div<{color: string;}>`
  padding-top: 8px;
  font-size: 12px;
  font-weight: 400;
  color: ${({ color }) => color};
`;

const Title = styled.div`
  font-size: 36px;
  font-weight: 700;
  line-height: 41.7px;
  letter-spacing: -1.2px;
`;

const EventTitle = styled.div`
  margin-top: 8px;
  font-size: 29px;
  font-weight: 400;
`;

export default RegistrationFull;